<template>
    <div>
        <vue-element-loading :active="loading" :is-full-screen="false" background-color="#FFFFFF" color="#005f32"
            spinner="bar-fade-scale" />
        <v-simple-table class="align-center" v-if="rows.length">
            <thead style="background-color: #005f32">
                <tr>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">Employee ({{ leaveType === 'Festival' ? 'Year ' + fyear.split('-')[0] : 'FY ' + fyear }})</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">Employee ID</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">Email</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " v-if="leaveType !== 'Festival'">LY Balance</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">{{ leaveType === 'Festival' ? 'FL Allotted' : 'CYCL Allotted' }}</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">{{ leaveType === 'Festival' ? 'FL Consumed' : 'CL Consumed' }}</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " v-if="leaveType !== 'Festival'">LA Penalty</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        " v-if="leaveType !== 'Festival'">NM Penalty</th>
                    <th class="text-left" style="
                          font-size: 15px;
                          color: #ffffff;
                          font-family: kumbhRegular;
                        ">{{ leaveType === 'Festival' ? 'FL Remaining' : 'Remaining leaves' }}</th>
                    <th class="text-left" style="font-size: 15px; color: #ffffff; font-family: kumbhRegular;"
                        v-if="userId && userId === '62a30b37d75aa11a84de313e'">Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, i) in rows" :key="i">
                    <td><span style="font-family: kumbhMedium">{{ item.employeeName }}</span></td>
                    <td><span style="font-family: kumbhMedium">{{ item.employeeCode }}</span></td>
                    <td><span style="font-family: kumbhMedium">{{ item.email }}</span></td>
                    <td v-if="leaveType !== 'Festival'"><span style="font-family: kumbhMedium">{{ item.lastYearBalance
                            }}</span></td>
                    <td><span style="font-family: kumbhMedium">{{ item.currentYearBalance }}</span></td>
                    <td><span style="font-family: kumbhMedium">{{ item.casualLeaveConsumed }}</span></td>
                    <td v-if="leaveType !== 'Festival'"><span style="font-family: kumbhMedium">{{ item.lateArrivalPenaltyCount }}</span></td>
                    <td v-if="leaveType !== 'Festival'"><span style="font-family: kumbhMedium">{{ item.nmPenaltyCount }}</span></td>
                    <td><span style="font-family: kumbhMedium">{{ item.remainingLeaves }}</span></td>
                    <td>
                        <v-icon small class="mr-2" style="cursor:pointer" @click="openEditModal(item)"
                            v-if="userId && userId === '62a30b37d75aa11a84de313e'">mdi-pencil</v-icon>
                    </td>
                </tr>
            </tbody>
        </v-simple-table>
        <div v-else class="pa-16 text-center">
            <span class="kumbhRegular">No Data found!</span>
        </div>
        <v-layout wrap justify-center v-if="pages > 1">
            <v-flex align-self-center>
                <div class="pt-2">
                    <v-pagination prev-icon="mdi-menu-left" next-icon="mdi-menu-right" :length="pages"
                        :total-visible="7" v-model="localPage" color="#005f32" @input="emitPageChange"></v-pagination>
                </div>
            </v-flex>
        </v-layout>

        <!-- Edit Modal -->
        <v-dialog v-model="editDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    Edit Leave Balance
                </v-card-title>
                <v-card-text>
                    <v-form ref="editForm">
                        <template v-if="leaveType === 'Festival'">
                            <v-text-field label="FL Allotted" v-model="editFormData.totalFestivalLeaves"
                                type="number"></v-text-field>
                            <v-text-field label="FL Consumed" v-model="editFormData.festivalLeavesConsumed"
                                type="number"></v-text-field>
                            <!-- <v-text-field label="FL Remaining" v-model="editFormData.festivalLeaveBalance"
                                type="number"></v-text-field> -->
                        </template>
                        <template v-else>
                            <v-text-field label="LY Balance" v-model="editFormData.lastYearLeaveBalance"
                                type="number"></v-text-field>
                            <v-text-field label="CYCL Allotted" v-model="editFormData.currentYearCasualLeaveBalance"
                                type="number"></v-text-field>
                            <v-text-field label="CL Consumed" v-model="editFormData.casualLeaveConsumed"
                                type="number"></v-text-field>
                            <v-text-field label="Late Arrival Penalty" v-model="editFormData.lateArrivalPenaltyCount"
                                type="number"></v-text-field>
                            <v-text-field label="NM Penalty" v-model="editFormData.nmPenaltyCount"
                                type="number"></v-text-field>
                        </template>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" text @click="editDialog = false">Cancel</v-btn>
                    <v-btn color="primary" @click="updateLeaveBalance">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar for error messages -->
        <v-snackbar v-model="showsnackbar" color="black" right>
            <v-layout wrap justify-center>
                <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
                <v-flex text-right>
                    <v-btn small :ripple="false" text @click="showsnackbar = false">
                        <v-icon style="color: white">mdi-close</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-snackbar>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        viewType: {
            type: String,
            required: true
        },
        currentPage: {
            type: Number,
            default: 1
        },
        searchQuery: {
            type: String,
            default: ''
        },
        leaveType: {
            type: String,
            default: 'Casual'
        },
        fyear: {
            type: String,
            default: ''
        },
        employeeId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            rows: [],
            pages: 0,
            userId: localStorage.getItem("userid"),
            totalData: 0,
            localPage: this.currentPage,
            editDialog: false,
            editFormData: {
                employeeId: null,
                lastYearLeaveBalance: 0,
                currentYearCasualLeaveBalance: 0,
                casualLeaveConsumed: 0,
                festivalLeaveBalance: 0,
                totalFestivalLeaves: 0,
                festivalLeavesConsumed: 0,
                lateArrivalPenaltyCount: 0,
                nmPenaltyCount: 0
            },
            showsnackbar: false,
            msg: ""
        };
    },
    watch: {
        viewType() {
            this.localPage = 1;
            this.fetchData();
        },
        currentPage(val) {
            this.localPage = val;
            this.fetchData();
        },
        searchQuery() {
            if (this.viewType === 'team') {
                this.localPage = 1;
                this.fetchData();
            }
        },
        leaveType() {
            this.localPage = 1;
            this.fetchData();
        },
        fyear() {
            this.localPage = 1;
            this.fetchData();
        },
        localPage(val) {
            if (val !== this.currentPage) {
                this.$emit('page-changed', val);
            }
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;
            this.rows = [];
            const payload = {
                viewType: this.viewType,
                page: this.localPage,
                limit: 20,
                type: this.leaveType,
                fyear: this.fyear
            };
            console.log("Fetching leave balance with payload:", payload);
            if (this.viewType === 'team') {
                if (this.searchQuery) {
                    payload.search = this.searchQuery;
                }
                if (this.employeeId) {
                    payload.employeeId = this.employeeId;
                }
            }
            axios({
                url: '/leave/balance/view',
                method: "POST",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                data: payload
            })
                .then(res => {
                    const data = res.data.data || [];
                    this.rows = data.map(item => {
                        if (this.leaveType === 'Festival') {
                            return {
                                employeeId: item.employeeId,
                                employeeName: item.employeeName || item.name || '-',
                                employeeCode: item.employeeCode || '-',
                                lastYearBalance: 0,
                                email: item.email || '-',
                                currentYearBalance: item.totalFestivalLeaves || 0,
                                casualLeaveConsumed: item.festivalLeavesConsumed || 0,
                                remainingLeaves: item.remainingFestivalLeaves || 0
                            };
                        } else {
                            return {
                                employeeId: item.employeeId,
                                employeeName: item.employeeName || item.name || '-',
                                employeeCode: item.employeeCode || '-',
                                lastYearBalance: item.lastYearLeaveBalance || 0,
                                email: item.email || '-',
                                currentYearBalance: item.currentYearCasualLeaveBalance || 0,
                                casualLeaveConsumed: item.casualLeaveConsumed || 0,
                                lateArrivalPenaltyCount: item.lateArrivalPenaltyCount || 0,
                                nmPenaltyCount: item.nmPenaltyCount || 0,
                                remainingLeaves: item.remainingLeaves || 0
                            };
                        }
                    });
                    this.totalData = res.data.totalLength || data.length;
                    this.pages = Math.ceil(this.totalData / (res.data.limit || 20));
                })
                .catch(() => {
                    this.rows = [];
                    this.pages = 0;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        emitPageChange(page) {
            this.localPage = page;
            this.$emit('page-changed', page);
        },
        openEditModal(item) {
            this.editFormData = {
                employeeId: item.employeeId,
                lastYearLeaveBalance: item.lastYearBalance,
                currentYearCasualLeaveBalance: item.currentYearBalance,
                casualLeaveConsumed: item.casualLeaveConsumed,
                lateArrivalPenaltyCount: item.lateArrivalPenaltyCount,
                nmPenaltyCount: item.nmPenaltyCount,
                festivalLeaveBalance: item.remainingLeaves,
                totalFestivalLeaves: item.currentYearBalance,  
                festivalLeavesConsumed: item.casualLeaveConsumed 
            };
            this.editDialog = true;
        },
        updateLeaveBalance() {
            this.loading = true;

            let apiUrl, apiData;
            if (this.leaveType === 'Festival') {
                apiUrl = '/leave/balance/festival/update';
                apiData = {
                    employeeId: this.editFormData.employeeId,
                    alloted: this.editFormData.totalFestivalLeaves,
                    festivalConsumed: this.editFormData.festivalLeavesConsumed,
                    fyear: this.fyear
                    // festivalLeaveBalance: this.editFormData.festivalLeaveBalance
                };
            } else {
                apiUrl = '/leave/balance/update';
                apiData = {
                    employeeId: this.editFormData.employeeId,
                    lastYearLeaveBalance: this.editFormData.lastYearLeaveBalance,
                    currentYearCasualLeaveBalance: this.editFormData.currentYearCasualLeaveBalance,
                    casualLeaveConsumed: this.editFormData.casualLeaveConsumed,
                    lateArrivalPenaltyCount: this.editFormData.lateArrivalPenaltyCount,
                    nmPenaltyCount: this.editFormData.nmPenaltyCount,
                    fyear: this.fyear
                };
            }

            axios({
                url: apiUrl,
                method: "POST",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
                data: apiData
            })
                .then((res) => {
                    if (res.data && res.data.status === false && res.data.msg) {
                        this.msg = res.data.msg;
                        this.showsnackbar = true;
                    } else {
                        this.editDialog = false;
                        this.fetchData();
                    }
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.msg) {
                        this.msg = err.response.data.msg;
                    } else {
                        this.msg = "Something went wrong!";
                    }
                    this.showsnackbar = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>

<style>
.tableHead {
    font-size: 15px;
    color: #ffffff;
    font-family: kumbhMedium;
}
</style>